<template>
  <div class="scoped-logo">
    <img :src="logo" alt />
  </div>
</template>
<script>
  import config from '@/tools/config'

  export default {
    computed: {
      logo() {
        return config.get('logo')
      }
    },
  }
</script>

<style lang="less" scoped>
  .scoped-logo {
    display: flex;
    justify-content: center;
    align-items: center;  

    img{
      display: block;
      height: 80%;
    }

    &.view-main-menu-logo{
      height: 120px;

      img{
        display: block;
        height: 50%;
      }
    }
  }
</style>